/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FiltersModalCreateLabelGroupMutationVariables = {|
  name: string,
  labels?: ?$ReadOnlyArray<?string>,
|};
export type FiltersModalCreateLabelGroupMutationResponse = {|
  +labelGroupCreate: ?{|
    +labelGroup: ?{|
      +name: string,
      +labels: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: string,
          |}
        |}>
      |},
    |}
  |}
|};
export type FiltersModalCreateLabelGroupMutation = {|
  variables: FiltersModalCreateLabelGroupMutationVariables,
  response: FiltersModalCreateLabelGroupMutationResponse,
|};
*/


/*
mutation FiltersModalCreateLabelGroupMutation(
  $name: String!
  $labels: [String]
) {
  labelGroupCreate(input: {name: $name, labels: $labels}) {
    labelGroup {
      name
      labels {
        edges {
          node {
            id
            name
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labels",
    "type": "[String]"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "labels",
        "variableName": "labels"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "LabelNodeConnection",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersModalCreateLabelGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LabelGroupCreatePayload",
        "kind": "LinkedField",
        "name": "labelGroupCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelGroupNode",
            "kind": "LinkedField",
            "name": "labelGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiltersModalCreateLabelGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LabelGroupCreatePayload",
        "kind": "LinkedField",
        "name": "labelGroupCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelGroupNode",
            "kind": "LinkedField",
            "name": "labelGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FiltersModalCreateLabelGroupMutation",
    "operationKind": "mutation",
    "text": "mutation FiltersModalCreateLabelGroupMutation(\n  $name: String!\n  $labels: [String]\n) {\n  labelGroupCreate(input: {name: $name, labels: $labels}) {\n    labelGroup {\n      name\n      labels {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '51f7be9990e1c9bd42867884c33f2ce0';

module.exports = node;
